import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

// Define your API types
export type ApiTypes =
  | 'employee'
  | 'farm'
  | 'machinery'
  | 'pesticide'
  | 'seed'
  | 'fertilizer'
  | 'tool';

//API endpoints for better search results experience
const CARD_DETAIL_APIS: Record<ApiTypes, string> = {
  employee: 'api/v2/store/employee-advertisement',
  farm: 'api/v2/store/farm-advertisement',
  machinery: 'api/v2/store/machinery-advertisement',
  pesticide: 'api/v2/store/pesticide-advertisement',
  seed: 'api/v2/store/seed-advertisement',
  fertilizer: 'api/v2/store/fertilizer-advertisement',
  tool: 'api/v2/store/tool-advertisement',
};

// Helper function to build the URL
const getCardDetailApiType = (type: ApiTypes): string => {
  const endpoint = CARD_DETAIL_APIS[type];
  // if (!endpoint) console.log(`Invalid API type: ${type}`);
  return `${endpoint}?guid=`;
};

// Query function
export const getCardDetail = async (ctx: QueryFunctionContext) => {
  const [, guid, type] = ctx.queryKey as [string, string, ApiTypes];

  const {data} = await request.get<
    | ICommonCardDetail
    | IEmployeeCardDetail
    | IToolsCardDetail
    | IMachineryDetail
    | IFarmDetails
    | ILabDetails
  >(`/${getCardDetailApiType(type)}${guid}`);

  return data;
};
